/**
 * 취기 지도 (공개)
 * 원고·조각·추천 글·화면 문구는 story5.content.json 에 있어요.
 * 편하게 고치려면: npm run story-editor → http://localhost:4545
 */
import content from "./story5.content.json";
import thumbnail from "../../assets/test/story5/thumbnail.jpg"; // Pexels 사진

export const story5 = {
  ...content,
  thumbnail,
  shareImage: `https://mango.moistmarketer.com${thumbnail}`,
};
